import { ServiceContractDelegation } from "../../Model/ServiceContractDelegation/ServiceContractDelegation";

export class GetServiceContractDelegationList {
    constructor(
        total,
        offset,
        limit,
        records
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
        return new GetServiceContractDelegationList(
            data.total,
            data.offset,
            data.limit,
            data.records.map((record) => {
                return ServiceContractDelegation.createFromResponseData(record);
            }),
        );
    }
}